/*
 *  Copyright (c) Qwoach LLC 2023. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 24/7/2023
 */

export const CoachingPackageType = Object.freeze({
	ONE_ON_ONE: "ONE_ON_ONE",
	GROUP: "GROUP",
})
